import { useEffect, useState } from "react";
import { Dialog, Snackbar, Alert, Tooltip } from "@mui/material";
import { authData, withAdminAuth } from "../../components/GetAuth";
import { Link as RouterLink } from "react-router-dom";
import styles from "./myprofile.module.css";
import Loader from "../../components/Loader";
import PageHeader from "../../components/PageHeader";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Copy, Edit3, Lock } from "react-feather";
import { useWebsite } from "../../../context/WebsiteContext";
import { useSiteBranding } from "../../../hooks/useSiteBranding";
import { withHttps } from "../../../utils/siteUrl";
import UpdateProfileForm from "../../components/popups/UpdateProfileForm";
import ChangePasswordForm from "../../components/popups/ChangePasswordForm";

const MyProfile = () => {
  const auth = authData();
  const [formOpenUpdateProfile, setFormOpenUpdateProfile] = useState(false);
  const [formOpenPassword, setFormOpenPassword] = useState(false);
  const userProfileData = localStorage.getItem("authData");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [loading, setLoading] = useState(false);
  const [customerLink, setCustomerLink] = useState("");

  const { websiteData } = useWebsite();
  useSiteBranding("My profile", websiteData);

  useEffect(() => {
    if (auth) {
      setCustomerLink(withHttps(auth?.company?.domain) + '/customer-sign-up/' + auth?.company?.urltoken);
    }
  }, [auth]);

  return (<div className={`${styles.MainDiv}`}>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <PageHeader title="My Profile" />
    <div className={`${styles.MainCard}`}>
      <div className={`${styles.Container}`}>
        <div className={`${styles.CusRow}`}>
          <div className={`${styles.CustomerDeSec}`}>
            <div className={`${styles.UserProCard2}`}>
              <div className={`${styles.UserHead}`}>
                <p className={`${styles.UserProName}`}>{auth?.name}</p>
                <div className={`${styles.UserHeadActions}`}>
                  <RouterLink className={`${styles.ProfileActionBU} ${styles.ProfileActionGhost}`} onClick={(e) => setFormOpenPassword(true)}><Lock /> Change Password</RouterLink>
                  <RouterLink className={`${styles.ProfileActionBU} ${styles.ProfileActionPrimary}`} onClick={(e) => setFormOpenUpdateProfile(true)}><Edit3 /> Edit Profile</RouterLink>
                </div>
              </div>
              <div className={`${styles.UserProDe}`}>
                <p className={`${styles.UserProDeList}`}><span>Name:</span> {auth?.name}</p>
                <p className={`${styles.UserProDeList}`}><span>Email:</span> {auth?.email}</p>
                <p className={`${styles.UserProDeList}`}><span>Phone No:</span> {auth?.phone}</p>
                {auth?.company && <>
                  <div className={`${styles.CustomerLinkRow}`}>
                    <span className={`${styles.CustomerLinkLabel}`}>Customer Registration Link:</span>
                    <div className={`${styles.CustomerLinkValueWrap}`}>
                      <CopyToClipboard text={customerLink}>
                        <Tooltip title={"Click to copy"}>
                          <span className={`${styles.CustomerLinkValue}`}>{customerLink}</span>
                        </Tooltip>
                      </CopyToClipboard>
                      <CopyToClipboard text={customerLink}>
                        <Tooltip title={"Click to copy"}>
                          <Copy className={`${styles.CustomerLinkCopyIcon}`} />
                        </Tooltip>
                      </CopyToClipboard>
                    </div>
                  </div>
                </>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Dialog open={formOpenUpdateProfile} onClose={(e) => setFormOpenUpdateProfile(false)} fullWidth maxWidth="sm">
      <UpdateProfileForm setFormOpenUpdateProfile={setFormOpenUpdateProfile.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setLoading={setLoading.bind(this)} userProfileData={userProfileData} />
    </Dialog>

    <Dialog open={formOpenPassword} onClose={(e) => setFormOpenPassword(false)} fullWidth maxWidth="sm">
      <ChangePasswordForm setFormOpen={setFormOpenPassword.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setLoading={setLoading.bind(this)} id={auth?.id} />
    </Dialog>

    <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={(e) => setSnackbarOpen(false)} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
      <Alert onClose={(e) => setSnackbarOpen(false)} severity={snackbarType} variant="filled" sx={{ width: "100%" }}>{snackbarMessage}</Alert>
    </Snackbar>
  </div >);
};

export default withAdminAuth(MyProfile);